import React from 'react';

const Content = ({ children }) => (
  <main className="w-1/2 flex flex-col h-screen bg-white">
    {children}
    <div className="h-[128px]"></div>
  </main>
);

export default Content;